const getJumpInSource = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlSource = urlParams.get('source');

    if (urlSource !== null) {
        sessionStorage.setItem('source', urlSource);
    }

    return sessionStorage.getItem('source');
};

export default getJumpInSource;
